import styled from 'styled-components';

export const StyledErrorMessage = styled.div`
  border: ${({ theme }) => theme.defaultColors.error} 1px solid;
  border-radius: 3px;
  color: ${({ theme }) => theme.defaultColors.error};
  padding: 20px;
  font-size: 14px;
  margin-bottom: 20px;
  background: #e2363f08;
`;
